<div class="container my-4" [formGroup]="form" >
    <div class="row">
      <div class="col-12">
        <span class="title_header_bar">Manage Reseller Product</span>
      </div>
    </div>
    <div class="card card_content">
      <div class="row d-flex mb-2 align-items-center flex-wrap grid-margin">
        <div class="col-md-3">
          <!-- <button type="button" class="btn btn-secondary mr-2" (click)="clearFilter()">
            <i class="fa fa-refresh"></i> Refresh
          </button> -->
          <app-button (refreshClicked)="clearFilter()"></app-button>

          <button type="button" class="btn excel_btn text-nowrap mr-2" (click)="exportAsXLSX()">
            <i class="fa fa-file-excel"></i> Export
          </button>
        </div>
        <div class="col-md-4 padd-right-file" style="display: flex;">
          <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'searchText-mat-field'" >
            <mat-label>Search</mat-label>
            <div class="search-input-container">
              <input placeholder="Enter Reseller Name / Reseller Code" id="search" matInput (keydown.enter)="getTableData(filterValue)" (keyup)="applyFilter($event)" type="text" #searchInput>
            </div>
          </mat-form-field>
          <button matSuffix mat-icon-button aria-label="Search" class="badge bg-light-blue image-button" (click)="getTableData(filterValue)">
            <mat-icon style="color: white;">search</mat-icon>
          </button>
        </div>

      </div>
      <div class="table-responsive mt-2 mb-4" >
        <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc" formArrayName="products">
          <ng-container matColumnDef="serviceProvider">
            <mat-header-cell *matHeaderCellDef mat-sort-header="serviceProvider">FNO</mat-header-cell>
            <mat-cell *matCellDef="let dataField; let i = index" [formGroupName]="i">
              <p class="text-truncate txtalign">{{dataField.serviceProvider}}</p>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="ProductName">
            <mat-header-cell *matHeaderCellDef mat-sort-header="productName">Product Name</mat-header-cell>
            <mat-cell *matCellDef="let dataField; let i = index" [formGroupName]="i">
              <p class="text-truncate txtalign">{{dataField.productName}}</p>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="ProductCode">
            <mat-header-cell *matHeaderCellDef mat-sort-header="productCode">Product Code</mat-header-cell>
            <mat-cell *matCellDef="let dataField; let i = index" [formGroupName]="i">
              <p class="text-truncate txtalign">{{dataField.productCode}}</p>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="Cost">
            <mat-header-cell *matHeaderCellDef mat-sort-header="resellerCost">Cost</mat-header-cell>
            <mat-cell *matCellDef="let dataField; let i = index" [formGroupName]="i" class="d-flex justify-content-center">
              <mat-form-field appearance="fill" hideRequiredMarker style="width: 40% !important;">
                <input matInput formControlName="resellerCost" maxlength="25" required class="col-12" autocomplete="off"
                (keydown.enter)="saveResellerProductCost()" style="text-align: center;">
              </mat-form-field>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple></mat-row>
        </mat-table>
      </div>
      <div *ngIf="data.length===0" class="text-center">
        No Results Found
      </div>
      <div class="table_pagenation">
        <mat-paginator #paginator [length]="dataSource!==null && dataSource.filteredData.length" [pageIndex]="0" [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]"></mat-paginator>
      </div>
      <div *ngIf="dataSource.filteredData.length > 0" class="row">
        <div class="col-xl-12 text-right">
          <button id="submitbutton" name="submit" type="submit" class="btn btn-secondary" (click)="saveResellerProductCost()">Submit</button>
        </div>
      </div>
    </div>
  </div>
